import { isDebug, isInChina } from "@/utils/commonUtils";

import { ZHONG_SHENG_DISTRIBUTOR_ID } from "@/utils/zhongShengConfig";
import { getLanguageFlag } from "@/utils/localStorageUtils";

export { ZHONG_SHENG_DISTRIBUTOR_ID };

const isCnLanguage = () => getLanguageFlag() === "zh-CN";

export const GOOGLE_MAP_KEY = 'AIzaSyD6mPlXayeKlFjNJaOckeU3mo0TXkaANBQ'


export const TD_MAP_KEY = '5645e20a9c7facfd6d0b6735c9fd700c';

export const MAPTILER_KEY = 'LcnJ1H0fGpWyrSyl4rbN';



export const WX_OFFICIAL_ACCOUNT = "wx_oa";



export const CONTACT_WECHAT = "https://work.weixin.qq.com/kfid/kfc81021af3b81760e3";
export const CONTACT_PHONE = "400-966-5278";


export const CHINA_DEFAULT_LOCATION = { lat: 39.9055, lng: 116.3976 }

export const CHINA_DEFAULT_LOCATION_MAPTILER = { lat: 31.21077, lng: 121.41821 }

export const MALAYSIA_DEFAULT_LOCATION = { lat: 3.139, lng: 101.6869 }

// export const MAP_REGION_CN = isInChina()?"CN":"MY";
// export const MAP_REGION_MY = isInChina()?"MY":"CN";

export const MAP_REGION_CN = "CN";
export const MAP_REGION_MY = "MY";


export const CHINA_IN_PROVINCE = [
    {  "text": "Beijing", "textcn": "北京市" },
    {  "text": "Shanghai", "textcn": "上海市" },
    {  "text": "Guangdong", "textcn": "广东省" },
    {  "text": "Sichuan", "textcn": "四川省" },
    {  "text": "Zhejiang", "textcn": "浙江省" },
    {  "text": "Jiangsu", "textcn": "江苏省" },
    {  "text": "Shaanxi", "textcn": "陕西省" },
    {  "text": "Chongqing", "textcn": "重庆市" },
    {  "text": "Hong Kong", "textcn": "HongKong" },
    {  "text": "Fujian", "textcn": "福建省" },
    {  "text": "Yunnan", "textcn": "云南省" },
    {  "text": "Hubei", "textcn": "湖北省" },
    {  "text": "Hunan", "textcn": "湖南省" },
    {  "text": "Shandong", "textcn": "山东省" },
    {  "text": "Heilongjiang", "textcn": "黑龙江省" },
    {  "text": "Henan", "textcn": "河南省" },
    {  "text": "Hainan", "textcn": "海南省" },
    {  "text": "Tianjin", "textcn": "天津市" },
    {  "text": "Anhui", "textcn": "安徽省" },
    {  "text": "Xinjiang Uygur Autonomous Region", "textcn": "新疆维吾尔自治区" },
    {  "text": "Liaoning", "textcn": "辽宁省" },
    {  "text": "Hebei", "textcn": "河北省" },
    {  "text": "Guangxi Zhuang Autonomous Region", "textcn": "广西壮族自治区" },
    {  "text": "Jiangxi", "textcn": "江西省" },
    {  "text": "Macau", "textcn": "Macau" },
    {  "text": "Jilin", "textcn": "吉林省" },
    {  "text": "Guizhou", "textcn": "贵州省" },
    {  "text": "Inner Mongolia Autonomous Region", "textcn": "内蒙古自治区" },
    {  "text": "Gansu", "textcn": "甘肃省" },
    {  "text": "Shanxi", "textcn": "山西省" },
    {  "text": "Tibet Autonomous Region", "textcn": "西藏自治区" },
    {  "text": "Ningxia Hui Autonomous Region", "textcn": "宁夏回族自治区" },
    {  "text": "Qinghai", "textcn": "青海省" }
]



const MALAYSIA_ALL_PROVINCE_DEBUG = [
    { "text": "KualaLumpur", "value": "202509091650503740050000" },
    { "text": "Selangor", "value": "202509091651067790050000" },
    { "text": "Pulau Pinang", "value": "202509091650564120050000" },
    { "text": "Sabah", "value": "202509091650575390050000" },
    { "text": "Johor", "value": "202509091650449460050000" },
    { "text": "Melaka", "value": "202509091650508650050000" },
    { "text": "Sarawak", "value": "202509091651016630050000" },
    { "text": "Putrajaya", "value": "202509091650573040050000" },
    { "text": "Negeri Sembilan", "value": "202509091650514270050000" },
    { "text": "Pahang", "value": "202509091650526300050000" },
    { "text": "Perak", "value": "202509091650544980050000" },
    { "text": "Kedah", "value": "202509091650466290050000" },
    { "text": "Kelantan", "value": "202509091650486640050000" },
    { "text": "Trengganu", "value": "202509091651083060050000" },
    { "text": "Perlis", "value": "202509091650561780050000" },
    { "text": "Labuan", "value": "202509091650506250050000" }
] 

const MALAYSIA_ALL_PROVINCE = [
    { "text": "KualaLumpur", "value": "202509091652250946240000" },
    { "text": "Johor", "value": "202509091652211966240000" },
    { "text": "Kedah", "value": "202509091652224146240000" },
    { "text": "Kelantan", "value": "202509091652238746240000" },
    { "text": "Labuan", "value": "202509091652252686240000" },
    { "text": "Melaka", "value": "202509091652254386240000" },
    { "text": "Negeri Sembilan", "value": "202509091652258536240000" },
    { "text": "Pahang", "value": "202509091652267266240000" },
    { "text": "Perak", "value": "202509091652280596240000" },
    { "text": "Perlis", "value": "202509091652292776240000" },
    { "text": "Pulau Pinang", "value": "202509091652299606240000" },
    { "text": "Putrajaya", "value": "202509091652305906240000" },
    { "text": "Sabah", "value": "202509091652307656240000" },
    { "text": "Sarawak", "value": "202509091652337426240000" },
    { "text": "Selangor", "value": "202509091652380606240000" },
    { "text": "Trengganu", "value": "202509091652391656240000" }
]


// 这个搞完了
// 默认的身份就是 北京市
export const CHINA_DEFAULT_PROVINCE_ID = isDebug() ? isInChina() ? "202509051311357767420000" : '202509091650503740050000' : isInChina() ? "202509051417568035210000" : '202509091652250946240000';
export const CHINA_ALL_PROVINCE = isDebug() ? isInChina() ? [
    { "text": "北京市", "value": "202509051310405897420000" },
    { "text": "上海市", "value": "202509051311357767420000" },
    { "text": "广东省", "value": "202509051312524177420000" },
    { "text": "四川省", "value": "202509051313156657420000" },
    { "text": "浙江省", "value": "202509051311443157420000" },
    { "text": "江苏省", "value": "202509051311369947420000" },
    { "text": "陕西省", "value": "202509051313524757420000" },
    { "text": "重庆市", "value": "202509051313127497420000" },
    { "text": "HongKong", "value": "202509090724261900290000" },
    { "text": "福建省", "value": "202509051311591397420000" },
    { "text": "云南省", "value": "202509051313361177420000" },
    { "text": "湖北省", "value": "202509051312353937420000" },
    { "text": "湖南省", "value": "202509051312431227420000" },
    { "text": "山东省", "value": "202509051312129947420000" },
    { "text": "黑龙江省", "value": "202509051311267847420000" },
    { "text": "河南省", "value": "202509051312235177420000" },
    { "text": "海南省", "value": "202509051313107807420000" },
    { "text": "天津市", "value": "202509051310418967420000" },
    { "text": "安徽省", "value": "202509051311511627420000" },
    { "text": "新疆维吾尔自治区", "value": "202509051314138467420000" },
    { "text": "辽宁省", "value": "202509051311143647420000" },
    { "text": "河北省", "value": "202509051310432347420000" },
    { "text": "广西壮族自治区", "value": "202509051313020187420000" },
    { "text": "江西省", "value": "202509051312054417420000" },
    { "text": "Macau", "value": "202509090724292970290000" },
    { "text": "吉林省", "value": "202509051311220867420000" },
    { "text": "贵州省", "value": "202509051313297267420000" },
    { "text": "内蒙古自治区", "value": "202509051311060697420000" },
    { "text": "甘肃省", "value": "202509051314006457420000" },
    { "text": "山西省", "value": "202509051310564507420000" },
    { "text": "西藏自治区", "value": "202509051313465527420000" },
    { "text": "宁夏回族自治区", "value": "202509051314116957420000" },
    { "text": "青海省", "value": "202509051314078997420000" }
] : MALAYSIA_ALL_PROVINCE_DEBUG : isInChina() ? isCnLanguage() ? [
    { "value": "202509051417568035210000", "text": "北京市" },
    { "value": "202509051418532155210000", "text": "上海市" },
    { "value": "202509051420163185210000", "text": "广东省" },
    { "value": "202509051420408585210000", "text": "四川省" },
    { "value": "202509051419022725210000", "text": "浙江省" },
    { "value": "202509051418545015210000", "text": "江苏省" },
    { "value": "202509051421193165210000", "text": "陕西省" },
    { "value": "202509051420379565210000", "text": "重庆市" },
    { "value": "202509091448135367040000", "text": "HongKong" },
    { "value": "202509051419181545210000", "text": "福建省" },
    { "value": "202509051421030075210000", "text": "云南省" },
    { "value": "202509051419561645210000", "text": "湖北省" },
    { "value": "202509051420063025210000", "text": "湖南省" },
    { "value": "202509051419327565210000", "text": "山东省" },
    { "value": "202509051418435705210000", "text": "黑龙江省" },
    { "value": "202509051419435825210000", "text": "河南省" },
    { "value": "202509051420358175210000", "text": "海南省" },
    { "value": "202509051417581655210000", "text": "天津市" },
    { "value": "202509051419095515210000", "text": "安徽省" },
    { "value": "202509051421413275210000", "text": "新疆维吾尔自治区" },
    { "value": "202509051418303305210000", "text": "辽宁省" },
    { "value": "202509051417595155210000", "text": "河北省" },
    { "value": "202509051420266455210000", "text": "广西壮族自治区" },
    { "value": "202509051419248055210000", "text": "江西省" },
    { "value": "202509091448161617040000", "text": "Macau" },
    { "value": "202509051418385725210000", "text": "吉林省" },
    { "value": "202509051420558885210000", "text": "贵州省" },
    { "value": "202509051418220535210000", "text": "内蒙古自治区" },
    { "value": "202509051421279505210000", "text": "甘肃省" },
    { "value": "202509051418126875210000", "text": "山西省" },
    { "value": "202509051421133935210000", "text": "西藏自治区" },
    { "value": "202509051421390015210000", "text": "宁夏回族自治区" },
    { "value": "202509051421351815210000", "text": "青海省" }
] : [
    { "value": "202509051417568035210000", "text": "Beijing", "textcn": "北京市" },
    { "value": "202509051418532155210000", "text": "Shanghai", "textcn": "上海市" },
    { "value": "202509051420163185210000", "text": "Guangdong", "textcn": "广东省" },
    { "value": "202509051420408585210000", "text": "Sichuan", "textcn": "四川省" },
    { "value": "202509051419022725210000", "text": "Zhejiang", "textcn": "浙江省" },
    { "value": "202509051418545015210000", "text": "Jiangsu", "textcn": "江苏省" },
    { "value": "202509051421193165210000", "text": "Shaanxi", "textcn": "陕西省" },
    { "value": "202509051420379565210000", "text": "Chongqing", "textcn": "重庆市" },
    { "value": "202509091448135367040000", "text": "Hong Kong", "textcn": "HongKong" },
    { "value": "202509051419181545210000", "text": "Fujian", "textcn": "福建省" },
    { "value": "202509051421030075210000", "text": "Yunnan", "textcn": "云南省" },
    { "value": "202509051419561645210000", "text": "Hubei", "textcn": "湖北省" },
    { "value": "202509051420063025210000", "text": "Hunan", "textcn": "湖南省" },
    { "value": "202509051419327565210000", "text": "Shandong", "textcn": "山东省" },
    { "value": "202509051418435705210000", "text": "Heilongjiang", "textcn": "黑龙江省" },
    { "value": "202509051419435825210000", "text": "Henan", "textcn": "河南省" },
    { "value": "202509051420358175210000", "text": "Hainan", "textcn": "海南省" },
    { "value": "202509051417581655210000", "text": "Tianjin", "textcn": "天津市" },
    { "value": "202509051419095515210000", "text": "Anhui", "textcn": "安徽省" },
    { "value": "202509051421413275210000", "text": "Xinjiang Uygur Autonomous Region", "textcn": "新疆维吾尔自治区" },
    { "value": "202509051418303305210000", "text": "Liaoning", "textcn": "辽宁省" },
    { "value": "202509051417595155210000", "text": "Hebei", "textcn": "河北省" },
    { "value": "202509051420266455210000", "text": "Guangxi Zhuang Autonomous Region", "textcn": "广西壮族自治区" },
    { "value": "202509051419248055210000", "text": "Jiangxi", "textcn": "江西省" },
    { "value": "202509091448161617040000", "text": "Macau", "textcn": "Macau" },
    { "value": "202509051418385725210000", "text": "Jilin", "textcn": "吉林省" },
    { "value": "202509051420558885210000", "text": "Guizhou", "textcn": "贵州省" },
    { "value": "202509051418220535210000", "text": "Inner Mongolia Autonomous Region", "textcn": "内蒙古自治区" },
    { "value": "202509051421279505210000", "text": "Gansu", "textcn": "甘肃省" },
    { "value": "202509051418126875210000", "text": "Shanxi", "textcn": "山西省" },
    { "value": "202509051421133935210000", "text": "Tibet Autonomous Region", "textcn": "西藏自治区" },
    { "value": "202509051421390015210000", "text": "Ningxia Hui Autonomous Region", "textcn": "宁夏回族自治区" },
    { "value": "202509051421351815210000", "text": "Qinghai", "textcn": "青海省" }
]
    :MALAYSIA_ALL_PROVINCE;


export const getAllProvinceList = (region) => {
    const useChina =
        region === MAP_REGION_CN || (region !== MAP_REGION_MY && isInChina());
    return isDebug() ? useChina ? [
        { "text": "北京市", "value": "202509051310405897420000" },
        { "text": "上海市", "value": "202509051311357767420000" },
        { "text": "广东省", "value": "202509051312524177420000" },
        { "text": "四川省", "value": "202509051313156657420000" },
        { "text": "浙江省", "value": "202509051311443157420000" },
        { "text": "江苏省", "value": "202509051311369947420000" },
        { "text": "陕西省", "value": "202509051313524757420000" },
        { "text": "重庆市", "value": "202509051313127497420000" },
        { "text": "HongKong", "value": "202509090724261900290000" },
        { "text": "福建省", "value": "202509051311591397420000" },
        { "text": "云南省", "value": "202509051313361177420000" },
        { "text": "湖北省", "value": "202509051312353937420000" },
        { "text": "湖南省", "value": "202509051312431227420000" },
        { "text": "山东省", "value": "202509051312129947420000" },
        { "text": "黑龙江省", "value": "202509051311267847420000" },
        { "text": "河南省", "value": "202509051312235177420000" },
        { "text": "海南省", "value": "202509051313107807420000" },
        { "text": "天津市", "value": "202509051310418967420000" },
        { "text": "安徽省", "value": "202509051311511627420000" },
        { "text": "新疆维吾尔自治区", "value": "202509051314138467420000" },
        { "text": "辽宁省", "value": "202509051311143647420000" },
        { "text": "河北省", "value": "202509051310432347420000" },
        { "text": "广西壮族自治区", "value": "202509051313020187420000" },
        { "text": "江西省", "value": "202509051312054417420000" },
        { "text": "Macau", "value": "202509090724292970290000" },
        { "text": "吉林省", "value": "202509051311220867420000" },
        { "text": "贵州省", "value": "202509051313297267420000" },
        { "text": "内蒙古自治区", "value": "202509051311060697420000" },
        { "text": "甘肃省", "value": "202509051314006457420000" },
        { "text": "山西省", "value": "202509051310564507420000" },
        { "text": "西藏自治区", "value": "202509051313465527420000" },
        { "text": "宁夏回族自治区", "value": "202509051314116957420000" },
        { "text": "青海省", "value": "202509051314078997420000" }
    ] : MALAYSIA_ALL_PROVINCE_DEBUG : useChina ? isCnLanguage() ? [
        { "value": "202509051417568035210000", "text": "北京市" },
        { "value": "202509051418532155210000", "text": "上海市" },
        { "value": "202509051420163185210000", "text": "广东省" },
        { "value": "202509051420408585210000", "text": "四川省" },
        { "value": "202509051419022725210000", "text": "浙江省" },
        { "value": "202509051418545015210000", "text": "江苏省" },
        { "value": "202509051421193165210000", "text": "陕西省" },
        { "value": "202509051420379565210000", "text": "重庆市" },
        { "value": "202509091448135367040000", "text": "HongKong" },
        { "value": "202509051419181545210000", "text": "福建省" },
        { "value": "202509051421030075210000", "text": "云南省" },
        { "value": "202509051419561645210000", "text": "湖北省" },
        { "value": "202509051420063025210000", "text": "湖南省" },
        { "value": "202509051419327565210000", "text": "山东省" },
        { "value": "202509051418435705210000", "text": "黑龙江省" },
        { "value": "202509051419435825210000", "text": "河南省" },
        { "value": "202509051420358175210000", "text": "海南省" },
        { "value": "202509051417581655210000", "text": "天津市" },
        { "value": "202509051419095515210000", "text": "安徽省" },
        { "value": "202509051421413275210000", "text": "新疆维吾尔自治区" },
        { "value": "202509051418303305210000", "text": "辽宁省" },
        { "value": "202509051417595155210000", "text": "河北省" },
        { "value": "202509051420266455210000", "text": "广西壮族自治区" },
        { "value": "202509051419248055210000", "text": "江西省" },
        { "value": "202509091448161617040000", "text": "Macau" },
        { "value": "202509051418385725210000", "text": "吉林省" },
        { "value": "202509051420558885210000", "text": "贵州省" },
        { "value": "202509051418220535210000", "text": "内蒙古自治区" },
        { "value": "202509051421279505210000", "text": "甘肃省" },
        { "value": "202509051418126875210000", "text": "山西省" },
        { "value": "202509051421133935210000", "text": "西藏自治区" },
        { "value": "202509051421390015210000", "text": "宁夏回族自治区" },
        { "value": "202509051421351815210000", "text": "青海省" }
    ] : [
        { "value": "202509051417568035210000", "text": "Beijing", "textcn": "北京市" },
        { "value": "202509051418532155210000", "text": "Shanghai", "textcn": "上海市" },
        { "value": "202509051420163185210000", "text": "Guangdong", "textcn": "广东省" },
        { "value": "202509051420408585210000", "text": "Sichuan", "textcn": "四川省" },
        { "value": "202509051419022725210000", "text": "Zhejiang", "textcn": "浙江省" },
        { "value": "202509051418545015210000", "text": "Jiangsu", "textcn": "江苏省" },
        { "value": "202509051421193165210000", "text": "Shaanxi", "textcn": "陕西省" },
        { "value": "202509051420379565210000", "text": "Chongqing", "textcn": "重庆市" },
        { "value": "202509091448135367040000", "text": "Hong Kong", "textcn": "HongKong" },
        { "value": "202509051419181545210000", "text": "Fujian", "textcn": "福建省" },
        { "value": "202509051421030075210000", "text": "Yunnan", "textcn": "云南省" },
        { "value": "202509051419561645210000", "text": "Hubei", "textcn": "湖北省" },
        { "value": "202509051420063025210000", "text": "Hunan", "textcn": "湖南省" },
        { "value": "202509051419327565210000", "text": "Shandong", "textcn": "山东省" },
        { "value": "202509051418435705210000", "text": "Heilongjiang", "textcn": "黑龙江省" },
        { "value": "202509051419435825210000", "text": "Henan", "textcn": "河南省" },
        { "value": "202509051420358175210000", "text": "Hainan", "textcn": "海南省" },
        { "value": "202509051417581655210000", "text": "Tianjin", "textcn": "天津市" },
        { "value": "202509051419095515210000", "text": "Anhui", "textcn": "安徽省" },
        { "value": "202509051421413275210000", "text": "Xinjiang Uygur Autonomous Region", "textcn": "新疆维吾尔自治区" },
        { "value": "202509051418303305210000", "text": "Liaoning", "textcn": "辽宁省" },
        { "value": "202509051417595155210000", "text": "Hebei", "textcn": "河北省" },
        { "value": "202509051420266455210000", "text": "Guangxi Zhuang Autonomous Region", "textcn": "广西壮族自治区" },
        { "value": "202509051419248055210000", "text": "Jiangxi", "textcn": "江西省" },
        { "value": "202509091448161617040000", "text": "Macau", "textcn": "Macau" },
        { "value": "202509051418385725210000", "text": "Jilin", "textcn": "吉林省" },
        { "value": "202509051420558885210000", "text": "Guizhou", "textcn": "贵州省" },
        { "value": "202509051418220535210000", "text": "Inner Mongolia Autonomous Region", "textcn": "内蒙古自治区" },
        { "value": "202509051421279505210000", "text": "Gansu", "textcn": "甘肃省" },
        { "value": "202509051418126875210000", "text": "Shanxi", "textcn": "山西省" },
        { "value": "202509051421133935210000", "text": "Tibet Autonomous Region", "textcn": "西藏自治区" },
        { "value": "202509051421390015210000", "text": "Ningxia Hui Autonomous Region", "textcn": "宁夏回族自治区" },
        { "value": "202509051421351815210000", "text": "Qinghai", "textcn": "青海省" }
    ]
        : MALAYSIA_ALL_PROVINCE;
}

export function getMapRegionProvinceList(region) {
    return getAllProvinceList(region);
}

export function getMapRegionDefaultProvinceId(region) {
    if (region === MAP_REGION_CN) {
        return isDebug()
            ? "202509051311357767420000"
            : "202509051417568035210000";
    }
    return isDebug()
        ? "202509091650503740050000"
        : "202509091652250946240000";
}

export function getMapRegionDefaultLocation(region) {
    return region === MAP_REGION_CN
        ? CHINA_DEFAULT_LOCATION_MAPTILER
        : MALAYSIA_DEFAULT_LOCATION;
}

export const CHINA_ALL_PROVINCE_ID_LIST = [
    "202509091448161617040000",
    "202509091448135367040000",
    "202509051421413275210000",
    "202509051421390015210000",
    "202509051421351815210000",
    "202509051421279505210000",
    "202509051421193165210000",
    "202509051421133935210000",
    "202509051421030075210000",
    "202509051420558885210000",
    "202509051420408585210000",
    "202509051420379565210000",
    "202509051420358175210000",
    "202509051420266455210000",
    "202509051420163185210000",
    "202509051420063025210000",
    "202509051419561645210000",
    "202509051419435825210000",
    "202509051419327565210000",
    "202509051419248055210000",
    "202509051419181545210000",
    "202509051419095515210000",
    "202509051419022725210000",
    "202509051418545015210000",
    "202509051418532155210000",
    "202509051418435705210000",
    "202509051418385725210000",
    "202509051418303305210000",
    "202509051418220535210000",
    "202509051418126875210000",
    "202509051417595155210000",
    "202509051417581655210000",
    "202509051417568035210000"
]



export const CHINA_ALL_CITY_LIST = [
    {
        text: '全部城市',
        value: "ALL"
    },
    {
        text: '上海市',
        value: "sh"
    },
    {
        text: '宿迁市',
        value: "sq"
    },
    {
        text: '镇江市',
        value: "zj"
    },
    {
        text: '南通市',
        value: "nt"
    },
    {
        text: '郑州市',
        value: "zz"
    },

]





export const DataEase_Config = () => ({
    baseUrl: 'http://106.14.35.23:9080/',
    token: '',
    qa_dvId: getLanguageFlag() == 'zh-CN' ? '1178796426407317504' : '1191092138130149376', //质保相关
    purchaseorder_dvid: getLanguageFlag() == 'zh-CN' ? '1185269019360497664' : '1191128164320022528', //采购订单
    inoutstock_dvid: getLanguageFlag() == 'zh-CN' ? '1176590676389924864' : '1191050919140265984',//出入库报表


    busiFlag: 'dashboard', //固定写法：dashboard 仪表板、dataV 数据大屏
    outerParams: '',// 外部参数
})
